import { CatPromotionModel } from "./cat-promotion.model";
import { HMGenericCatalog } from "../../app/model/hypermatrix-catalogs-models";
import { CatalogModel } from "../../app/model/other-catalogs-models";

export class CreateCombinationsSend{
    listAnchor?:HMGenericCatalog[];
    listBusinessProduct?:HMGenericCatalog[];
    listCategory?:CatalogModel[];
    listEmployeeJob?:CatalogModel[];
    listFinancing?:CatalogModel[];
    listAfiliate?:CatalogModel[];
    listPaymentTerm?:CatalogModel[];
    listPromotion?:CatPromotionModel[];
    listSchema?:CatalogModel[];
}